import { render, staticRenderFns } from "./relatorio-detalhe.vue?vue&type=template&id=ba64cc14"
import script from "./relatorio-detalhe.vue?vue&type=script&lang=ts"
export * from "./relatorio-detalhe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports